import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPageType, getPageUrl, getCookieId, getClientType, getOS, getUA, getOsVersion, fix, generateUUId } from "../../utils";
import pkg from "../../../../package.json";
import { getPageIdInfo } from "../../../utils/common";
import legoPerfPc from "../..";

// 初始化 基础参数
export var initBase = function initBase(task) {
  var _navigator$connection, _navigator$connection2, _getPageUrl, _getPageIdInfo;
  var _task$params = task.params,
    params = _task$params === void 0 ? {
      backup: {}
    } : _task$params,
    _task$options = task.options,
    options = _task$options === void 0 ? {} : _task$options,
    session = task.session;
  var pagestate = task.ctx.state; // 页面状态  "pageload" || "navigation"
  var platfrom = navigator['platform'] ? navigator['platform'] + '-' : '';
  var version = pkg && pkg.version || '';
  var cookieid = getCookieId();
  var uid = (options === null || options === void 0 ? void 0 : options.uid) || legoPerfPc.getuid() || getCookieId();
  var fromType = 'pc';
  var clientType = getClientType();
  var ua = getUA();
  var os = getOS();
  var isoffline = 0;
  var isprerender = 0;
  var iszz = 0;
  var zzv = '';
  var zzt = '';
  var phoneType = "".concat(platfrom).concat(clientType, "-").concat(getOsVersion());
  // safari 不支持 navigator.connection
  var netType = ((_navigator$connection = navigator['connection']) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType) || '';
  var rtt = ((_navigator$connection2 = navigator['connection']) === null || _navigator$connection2 === void 0 ? void 0 : _navigator$connection2.rtt) || 0;
  var operatorType = '';
  var pageurl = (_getPageUrl = getPageUrl()) === null || _getPageUrl === void 0 ? void 0 : _getPageUrl.toLowerCase();
  var pageId = (_getPageIdInfo = getPageIdInfo()) === null || _getPageIdInfo === void 0 ? void 0 : _getPageIdInfo.pageId;
  var pagetype = getPageType(options === null || options === void 0 ? void 0 : options.needMergeRoute, options === null || options === void 0 ? void 0 : options.needPathName);
  var actiontype = 'PERFORMANCE';
  var appid = 'ZHUANZHUAN';
  var abtesttype = 'ALL';
  var sessionid = (session === null || session === void 0 ? void 0 : session.sessionid) || generateUUId();
  Object.assign(params, {
    pagetype: (options === null || options === void 0 ? void 0 : options.pagetype) || pagetype,
    actiontype: (options === null || options === void 0 ? void 0 : options.actiontype) || actiontype,
    appid: (options === null || options === void 0 ? void 0 : options.appid) || appid,
    abtesttype: (options === null || options === void 0 ? void 0 : options.abtesttype) || abtesttype,
    os: os,
    ua: ua,
    backup: _objectSpread(_objectSpread({}, params.backup), {}, {
      sessionid: sessionid,
      metrictype: 'base',
      // 标识性能数据类型，方便会话上报 RD 合并数据
      pagestate: pagestate,
      pageid: (options === null || options === void 0 ? void 0 : options.pageId) || pageId,
      pageurl: pageurl,
      fromType: (options === null || options === void 0 ? void 0 : options.fromType) || fromType,
      version: version,
      isoffline: isoffline,
      // 是否离线包
      isprerender: isprerender,
      // 是否预渲染， 主动上报时设置
      zzv: zzv,
      zzt: zzt,
      phoneType: phoneType,
      isFirst: 1,
      iszz: iszz,
      clientType: clientType,
      netType: netType,
      rtt: rtt,
      operatorType: operatorType,
      cookieid: cookieid,
      uid: uid
    })
  });

  // console.log('initBase', params)
  return task;
};
// NavigatorTiming
export var getPerformanceTimingData = function getPerformanceTimingData(task) {
  var _window;
  if (!((_window = window) !== null && _window !== void 0 && (_window = _window.performance) !== null && _window !== void 0 && _window.timing)) return {};
  var metrics = task.metrics;
  // 异步指标 或 paint 指标
  var _ref = metrics || {},
    fmp = _ref.fmp,
    firstPiantTime = _ref.firstPiantTime,
    fp = _ref.fp,
    fcp = _ref.fcp;
  //
  var initMetrics = {
    // 非 NavigatorTiming 指标
    firstPiantTime: firstPiantTime || 0,
    // firstPiantTime 为旧数据字段
    fp: fp || 0,
    fcp: fcp || 0,
    fmp: fmp || 0
  };
  var state = task.ctx.state;
  // Performance 数据大于10s 在后端认为是无效值 计算时会过滤掉
  var result = {
    blankTime: 0,
    // 白屏时长
    rdStartTime: 0,
    rdEndTime: 0,
    fStartTime: 0,
    cStartTime: 0,
    cEndTime: 0,
    dnsStartTime: 0,
    dnsEndTime: 0,
    dnsTime: 0,
    fpTime: 0,
    fpEndTime: 0,
    domStartTime: 0,
    readyTime: 0,
    atfStartTime: 0,
    domLoadedTime: 0,
    atfTime: 0,
    // 首屏时间
    activeTime: 0,
    loadTime: 0,
    // 完全加载时间
    webviewInitTime: 0,
    domInteractiveTime: 0,
    fmp: 0
  };
  var ptiming = performance.timing;
  if (state === 'pageload') {
    // 白屏时间
    result.blankTime = fix(ptiming.responseStart - ptiming.navigationStart);
    // 重定向开始
    result.rdStartTime = fix(ptiming.redirectStart - ptiming.navigationStart);
    // 重定向结束
    result.rdEndTime = fix(ptiming.redirectEnd - ptiming.navigationStart);
    // 浏览器发起请求的时间
    result.fStartTime = fix(ptiming.fetchStart - ptiming.navigationStart);
    // connect开始
    result.cStartTime = fix(ptiming.connectStart - ptiming.navigationStart);
    // connect结束
    result.cEndTime = fix(ptiming.connectEnd - ptiming.navigationStart);
    // dns开始时间
    result.dnsStartTime = fix(ptiming.domainLookupStart - ptiming.navigationStart);
    // dns结束时间
    result.dnsEndTime = fix(ptiming.domainLookupEnd - ptiming.navigationStart);
    // dns耗时
    result.dnsTime = fix(ptiming.domainLookupEnd - ptiming.domainLookupStart);
    // 浏览器开始接受数据的时间，首包时间,即ttf时间, 浏览器收到从服务端（或缓存，本地资源）响应回的第一个字节的数据的时刻
    result.fpTime = fix(ptiming.responseStart - ptiming.navigationStart);
    // http请求耗时
    result.fpEndTime = fix(ptiming.responseEnd - ptiming.navigationStart);
    // 开始解析收到的 HTML 页面的第一个字节。
    result.domStartTime = fix(ptiming.domLoading - ptiming.navigationStart);
    // 完成所有 script 加载和解析之后, 当 DOMContentLoaded 事件触发之前，浏览器完成所有script（包括设置了defer的script）的下载和解析之后的时刻
    // result.domContentLoadedEventStart = fix(ptiming.domContentLoadedEventStart - ptiming.navigationStart)
    // document 文档解析完成，不包括异步js，即 readyState 变为'interactive'，readystartechange触发，指文档解析完成的时刻，包括在“传统模式”下被阻塞的通过script标签加载的内容（除了使用defer或者async属性异步加载的情况）
    // 文档已被解析，"正在加载" 状态结束, DOM 元素可以被访问, 但是诸如图像，样式表和框架之类的子资源仍在加载
    result.domInteractiveTime = fix(ptiming.domInteractive - ptiming.navigationStart);
    // dom 完全构建包括样式
    result.domLoadedTime = fix(ptiming.domContentLoadedEventStart - ptiming.navigationStart);
    // domReady 时间 ，SSR 项目首屏时间
    result.readyTime = fix(ptiming.domContentLoadedEventEnd - ptiming.navigationStart);
    if (!result.atfStartTime) result.atfStartTime = result.readyTime;
    // 可操作时间，包括使用图片，document.readyState 属性设置为 "complete" 与 onload 近似
    result.activeTime = fix(ptiming.domComplete - ptiming.navigationStart);
    // 完全加载
    result.loadTime = Math.max(fix(ptiming.loadEventEnd - ptiming.navigationStart), 100 + Math.max(fix(fmp || 0)));
    if (result.loadTime !== 0) {
      result.atfTime = fmp || result.loadTime;
    } else {
      result.atfTime = result.activeTime;
      result.loadTime = result.atfTime + 100;
    }
  }

  // router 切换页面，只 mock 核心指标，其他不处理
  // （因为此时没有有意义的 timing 值，但是约定需要上报）
  if (state === 'navigation') {
    // 白屏时间
    result.blankTime = 10;
    // domReady 时间
    result.readyTime = 20;
    //
    initMetrics.firstPiantTime = 20;
    // 
    result.fmp = initMetrics.fmp || 200;
    // 首屏时间
    result.atfTime = initMetrics.fmp || 200;
    // 完全加载
    result.loadTime = result.atfTime + 200;
  }

  // console.log('getPerformanceTimingData', result);
  Object.assign(metrics, initMetrics, result);
  return result;
};